import React from 'react';

const CaseTabs = ({ selectedTab, setSelectedTab, counts }) => {
    const tabs = [
        { id: 'stages', label: 'STAGES', count: counts.stages, icon: '🎯' },
        { id: 'tasks', label: 'TASKS', count: `${counts.tasksOpen}/${counts.tasksTotal}`, icon: '✅' },
        { id: 'notes', label: 'LOGS', count: counts.notes, icon: '📝' },
        { id: 'applications', label: 'APPS', count: counts.apps, icon: '🎓' },
        { id: 'offers', label: 'OFFERS', count: counts.offers, icon: '📄' },
        { id: 'visa', label: 'VISA', count: counts.visa, icon: '🛂' },
        { id: 'credentials', label: 'CREDS', count: counts.credentials, icon: '🔐' },
        { id: 'finance', label: 'FINANCE', count: `${counts.invoices}/${counts.payments}`, icon: '💳' },
        { id: 'timeline', label: 'TIMELINE', count: null, icon: '🕒' },
    ];

    const handleTabClick = (id) => {
        setSelectedTab(id);
        try { localStorage.setItem('case_detail_tab', id); } catch { }
    };

    return (
        <div className="flex items-center gap-1 mb-6 overflow-x-auto pb-2 border-b border-gray-800">
            {tabs.map(tab => (
                <button
                    key={tab.id}
                    onClick={() => handleTabClick(tab.id)}
                    className={`
            px-4 py-2 rounded-t-lg text-xs font-bold tracking-wider transition-all duration-200 whitespace-nowrap border-t-2 border-x border-transparent
            ${selectedTab === tab.id
                            ? 'bg-gray-800 text-blue-400 border-t-blue-500 border-x-gray-700'
                            : 'text-gray-500 hover:text-gray-300 hover:bg-gray-800/50'}
          `}
                >
                    <span className="mr-2 opacity-70">{tab.icon}</span>
                    {tab.label}
                    {tab.count !== null && (
                        <span className={`ml-2 px-1.5 py-0.5 rounded text-[10px] ${selectedTab === tab.id ? 'bg-blue-900/30 text-blue-300' : 'bg-gray-700 text-gray-400'}`}>
                            {tab.count}
                        </span>
                    )}
                </button>
            ))}
        </div>
    );
};

export default CaseTabs;
